import React, { useEffect } from 'react';
import { withAppContext } from '@ctsu/loader';
import { withStyles } from '@material-ui/core/styles';
import atoms from 'ctsutheme/components/atoms';
import { compose, withHandlers, withState } from 'recompose';
import { MUIDatePicker } from 'components/FormHelpers/DatePicker';
import {
  getUIDateFormat,
  getUIDTFormat,
  getApiDateFormat,
  useCtxParseValue,
  GetFromCtxValue,
  getEmptyValue
} from 'helpers';
import { ListItem, ListItemText } from '@material-ui/core';
import { MUISelect, MUITextBox, ValidatorForm } from 'components/FormHelpers/FormInputs';
import _ from 'lodash';
import { FormViewContent } from 'components/FormViewContent';
import { openConfirmation } from 'helpers/Confirmation';
import { CTSUCardActions } from 'components';
import molecules from 'ctsutheme/components/molecules';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';


const { List, ListSubHeader } = molecules;
const { Divider, Typography } = atoms;

const styles = theme => ({
  textField: {
    // width: 300,
    // textAlign: 'left',
    // textIndent: 5
  },
  editable: {
    // width: 70
  },
  calender: {
    // width: 170
  }
});

const IntegrationInfo = ({
  classes,
  intInfo,
  state,
  handleChange,
  handleDateChange,
  saveIntInfo,
  closeIntegrations,
  setState,
  activationDate,
  clearIntFields,
  psrInfo
}) => {
  useEffect(() => {
    setState({ ...intInfo });
    ValidatorForm.addValidationRule('cmCheck', value => (
      value
        && activationDate
        && value !== 'Invalid Date'
        && value > getUIDTFormat(activationDate)
    ));
  }, [intInfo, activationDate, setState]);

  const { protocolIntCMPatientSelMethod } = useCtxParseValue(
    'LOV_INT_CM_PATIENT_SEL_METHOD'
  );

  return (
    <ValidatorForm onSubmit={saveIntInfo}>
      <FormViewContent
        primaryText="LPO Supplemental Documents Posted?"
        secondaryText={(
          <MUISelect
            name="isCtsuMenu"
            title="LPO Supplemental Documents Posted"
            className={classes.editable}
            value={state.isCtsuMenu === true}
            onChange={handleChange}
          >
            <ListItem button value key="isCtsuMenuYes">
              <ListItemText primary="Yes" />
            </ListItem>
            <ListItem button value={false} key="isCtsuMenuNo">
              <ListItemText primary="No" />
            </ListItem>
          </MUISelect>
)}
      />
      <Divider />
      <FormViewContent
        className="MuiListItem-react-datepicker"
        primaryText="Website Activation Date"
        secondaryText={(
          <MUIDatePicker
            title="Website Activation Date"
            id="date-ctsuMenuDate"
            value={getUIDateFormat(state.ctsuMenuDate)}
            onChange={handleDateChange('ctsuMenuDate')}
            name="ctsuMenuDate"
            className={classes.calender}
          />
)}
      />
      <Divider />
      <FormViewContent
        primaryText="TRIAD Protocol?"
        secondaryText={(
          <MUISelect
            title="TRIAD Protocol"
            value={state.isTriadProt === true}
            name="isTriadProt"
            className={classes.editable}
            // validators={["required"]}
            // errorMessages={["TRIAD Protocol is required"]}
            onChange={handleChange}
          >
            <ListItem button value key="isTriadProtYes">
              <ListItemText primary="Yes" />
            </ListItem>
            <ListItem button value={false} key="isTriadProtNo">
              <ListItemText primary="No" />
            </ListItem>
          </MUISelect>
)}
      />
      <Divider />
      <FormViewContent
        className="MuiListItem-react-datepicker"
        primaryText="TRIAD Activation Date"
        secondaryText={(
          <MUIDatePicker
            title="TRIAD Activation Date"
            id="date-triadActivationDate"
            value={getUIDateFormat(state.triadActivationDate)}
            onChange={handleDateChange('triadActivationDate')}
            disabled={!state.isTriadProt}
            name="triadActivationDate"
            validators={state.isTriadProt ? ['required'] : []}
            errorMessages={state.isTriadProt ? ['Required Field'] : []}
            className={classes.calender}
          />
)}
      />
      <Divider />
      <FormViewContent
        primaryText="RT QA Flag?"
        secondaryText={(
          <MUISelect
            value={state.isRtQaStudy === true}
            className={classes.editable}
            name="isRtQaStudy"
            title="RT QA Flag"
            onChange={handleChange}
            disabled={!state.isTriadProt}
          >
            <ListItem button value key="isRtQaStudyYes">
              <ListItemText primary="Yes" />
            </ListItem>
            <ListItem button value={false} key="isRtQaStudyNo">
              <ListItemText primary="No" />
            </ListItem>
          </MUISelect>
)}
      />
      <Divider />
      <FormViewContent
        className="MuiListItem-react-datepicker"
        primaryText="RT QA Activation Date"
        secondaryText={(
          <MUIDatePicker
            title="RT QA Activation Date"
            id="date-rtQaActivationDate"
            value={getUIDateFormat(state.rtQaActivationDate)}
            onChange={handleDateChange('rtQaActivationDate')}
            disabled={!state.isRtQaStudy}
            name="rtQaActivationDate"
            validators={state.isRtQaStudy ? ['required'] : []}
            errorMessages={state.isRtQaStudy ? ['Required Field'] : []}
            className={classes.calender}
          />
)}
      />
      <FormViewContent
        primaryText="IROC Full Integration"
        secondaryText={(
          <MUISelect
            name="isIrocFullIntegration"
            title="IROC Full Integration"
            className={classes.editable}
            value={state.isIrocFullIntegration === true}
            onChange={handleChange}
          >
            <ListItem button value key="isIrocFullIntegrationYes">
              <ListItemText primary="Yes" />
            </ListItem>
            <ListItem button value={false} key="isIrocFullIntegrationNo">
              <ListItemText primary="No" />
            </ListItem>
          </MUISelect>
)}
      />
      <FormViewContent
        primaryText="DQP Supported"
        secondaryText={(
          <MUISelect
            value={state.isDqpSupported === true}
            className={classes.editable}
            name="isDqpSupported"
            title="Dqp Supported"
            onChange={handleChange}
          >
            <ListItem button value key="isDqpSupportedYes">
              <ListItemText primary="Yes" />
            </ListItem>
            <ListItem button value={false} key="isDqpSupportedNo">
              <ListItemText primary="No" />
            </ListItem>
          </MUISelect>
)}
      />
      <Divider />
      <FormViewContent
        primaryText="Using TSDV?"
        secondaryText={(
          <MUISelect
            title="Using TSDV"
            value={state.isTsdv === true}
            className={classes.editable}
            name="isTsdv"
            onChange={handleChange}
          >
            <ListItem button value key="isTsdvYes">
              <ListItemText primary="Yes" />
            </ListItem>
            <ListItem button value={false} key="isTsdvNo">
              <ListItemText primary="No" />
            </ListItem>
          </MUISelect>
)}
      />
      <Divider />
      <FormViewContent
        primaryText="E-Pro Study?"
        secondaryText={(
          <MUISelect
            title="E-Pro Study"
            value={state.isEproStudy === true}
            className={classes.editable}
            name="isEproStudy"
            onChange={handleChange}
          >
            <ListItem button value key="isEproStudyYes">
              <ListItemText primary="Yes" />
            </ListItem>
            <ListItem button value={false} key="isEproStudyNo">
              <ListItemText primary="No" />
            </ListItem>
          </MUISelect>
)}
      />
      <Divider />
      <FormViewContent
        primaryText="DCP001 Screening Log?"
        secondaryText={(
          <MUISelect
            title="DCP001 Screening Log"
            value={state.isScreeningLog === true}
            className={classes.editable}
            name="isScreeningLog"
            onChange={handleChange}
          >
            <ListItem button value key="isScreeningLogYes">
              <ListItemText primary="Yes" />
            </ListItem>
            <ListItem button value={false} key="isScreeningLogNo">
              <ListItemText primary="No" />
            </ListItem>
          </MUISelect>
)}
      />
      <Divider />
      <FormViewContent
        primaryText="IRB Exempt?"
        secondaryText={(
          <MUISelect
            title="IRB Exempt"
            value={state.isIrbExempt === true}
            className={classes.editable}
            name="isIrbExempt"
            disabled={psrInfo.length > 0}
            onChange={handleChange}
          >
            <ListItem button value key="isIrbExemptYes">
              <ListItemText primary="Yes" />
            </ListItem>
            <ListItem button value={false} key="isIrbExemptNo">
              <ListItemText primary="No" />
            </ListItem>
          </MUISelect>
)}
      />
      <Divider />
      <List
        subheader={(
          <ListSubHeader flex>
            <Typography data-id="centralMonitor" inline primary>
            Central Monitoring
            </Typography>
          </ListSubHeader>
        )}
      >
        <FormViewContent
          primaryText="Central Monitoring?"
          secondaryText={(
            <MUISelect
              title="Central Monitoring"
              value={state.isCentralMonitoring === true}
              className={classes.editable}
              name="isCentralMonitoring"
              onChange={handleChange}
            >
              <ListItem button value key="isCentralMonitoringYes">
                <ListItemText primary="Yes" />
              </ListItem>
              <ListItem button value={false} key="isCentralMonitoringNo">
                <ListItemText primary="No" />
              </ListItem>
            </MUISelect>
)}
        />
        <Divider />
        <FormViewContent
          className="MuiListItem-react-datepicker"
          primaryText="CM Effective Date"
          secondaryText={(
            <MUIDatePicker
              title="CM Effective Date"
              id="date-cmEffectiveDate"
              value={getUIDateFormat(state.cmEffectiveDate)}
              onChange={handleDateChange('cmEffectiveDate')}
              validators={state.cmEffectiveDate ? ['cmCheck'] : []}
              errorMessages={state.cmEffectiveDate ? [`Please provide a date which is grater than ${activationDate}`] : []}
              name="cmEffectiveDate"
              className={classes.calender}
            />
)}
        />
        <Divider />
        <FormViewContent
          primaryText="Patient Selection Method"
          secondaryText={(
            <MUISelect
              title="Patient Selection Method"
              value={getEmptyValue(state.cmPatientSelectionMethod)}
              name="cmPatientSelectionMethod"
              onChange={handleChange}
              className={classes.textField}
            >
              {_.map(protocolIntCMPatientSelMethod, (item, i) => (
                <ListItem
                  button
                  value={item.value}
                  key={_.uniqueId('int_patient_sel')}
                >
                  <ListItemText primary={item.code} />
                </ListItem>
              ))}
            </MUISelect>
)}
        />
        <Divider />
        <FormViewContent
          primaryText="Patient First X"
          secondaryText={(
            <MUITextBox
              title="CM Patient First X"
              value={getEmptyValue(state.cmFirstXPatient)}
              name="cmFirstXPatient"
              validators={['matchRegexp:^[0-9]+$', 'maxNumber:99999999']}
              errorMessages={['Please enter numeric value', 'Max number allowed is 99999999']}
              className={classes.textField}
              onChange={handleChange}
            />
)}
        />
        <Divider />
        <FormViewContent
          primaryText="Patient Next Y"
          secondaryText={(
            <MUITextBox
              title="CM Patient Next Y"
              value={getEmptyValue(state.cmNextYPatient)}
              name="cmNextYPatient"
              validators={['matchRegexp:^[0-9]+$', 'maxNumber:99999999']}
              errorMessages={['Please enter numeric value', 'Max number allowed is 99999999']}
              className={classes.textField}
              onChange={handleChange}
            />
)}
        />
      </List>
      <Divider />

      <List
        subheader={(
          <ListSubHeader flex>
            <Typography inline primary data-id="eligibilityReview">
             Eligibility Review
            </Typography>
          </ListSubHeader>
        )}
      >
        <FormViewContent
          primaryText="Eligibility Review?"
          secondaryText={(
            <MUISelect
              title="Eligibility Review"
              value={state.isSupportEligibilityReview === true}
              className={classes.editable}
              name="isSupportEligibilityReview"
              onChange={handleChange}
            >
              <ListItem button value key="isSupportEligibilityReviewYes">
                <ListItemText primary="Yes" />
              </ListItem>
              <ListItem button value={false} key="isSupportEligibilityReviewNo">
                <ListItemText primary="No" />
              </ListItem>
            </MUISelect>
)}
        />
        <Divider />
        <FormViewContent
          className="MuiListItem-react-datepicker"
          primaryText="ER Effective Date"
          secondaryText={(
            <MUIDatePicker
              title="ER Effective Date"
              id="date-erEffectiveDate"
              value={getUIDateFormat(state.erEffectiveDate)}
              onChange={handleDateChange('erEffectiveDate')}
              validators={state.erEffectiveDate ? ['cmCheck'] : []}
              errorMessages={state.erEffectiveDate ? [`Please provide a date which is grater than ${activationDate}`] : []}
              name="erEffectiveDate"
              className={classes.calender}
              popperPlacement="top-start"
            />
)}
        />
        <Divider />
        <FormViewContent
          className="MuiListItem-react-datepicker"
          primaryText="ER Patient Select Effective Date"
          secondaryText={(
            <MUIDatePicker
              title="ER Patient Select Effective Date"
              id="date-erPatientSelectEffectiveDate"
              value={getUIDateFormat(state.erPatientSelectEffectiveDate)}
              onChange={handleDateChange('erPatientSelectEffectiveDate')}
              validators={state.erPatientSelectEffectiveDate ? ['cmCheck'] : []}
              errorMessages={state.erPatientSelectEffectiveDate ? [`Please provide a date which is grater than ${activationDate}`] : []}
              name="erPatientSelectEffectiveDate"
              className={classes.calender}
              popperPlacement="top-start"
            />
)}
        />
        <Divider />
        <FormViewContent
          primaryText="ER Patient Selection Method"
          secondaryText={(
            <MUISelect
              title="ER Patient Selection Method"
              value={getEmptyValue(state.erPatientSelectionMethod)}
              name="erPatientSelectionMethod"
              onChange={handleChange}
              className={classes.textField}
            >
              {_.map(protocolIntCMPatientSelMethod, (item, i) => (
                <ListItem
                  button
                  value={item.value}
                  key={_.uniqueId('int_er_patient_sel')}
                >
                  <ListItemText primary={item.code} />
                </ListItem>
              ))}
            </MUISelect>
)}
        />
        <Divider />
        <FormViewContent
          primaryText="Patient First X"
          secondaryText={(
            <MUITextBox
              title="ER Patient First X"
              value={getEmptyValue(state.erFirstXPatients)}
              name="erFirstXPatients"
              validators={['matchRegexp:^[0-9]+$', 'maxNumber:99999999']}
              errorMessages={['Please enter numeric value', 'Max number allowed is 99999999']}
              className={classes.textField}
              onChange={handleChange}
            />
)}
        />
        <Divider />
        <FormViewContent
          primaryText="Patient Next Y"
          secondaryText={(
            <MUITextBox
              title="ER Patient Next Y"
              value={getEmptyValue(state.erNextYPatients)}
              name="erNextYPatients"
              validators={['matchRegexp:^[0-9]+$', 'maxNumber:99999999']}
              errorMessages={['Please enter numeric value', 'Max number allowed is 99999999']}
              className={classes.textField}
              onChange={handleChange}
            />
)}
        />
      </List>
      <Divider />
      <CTSUCardActions
        clearClick={clearIntFields}
        cancelClick={closeIntegrations}
        disabled={_.isEqual(state, intInfo)}
      />
    </ValidatorForm>
  );
};

IntegrationInfo.propTypes = {
  intInfo: PropTypes.oneOfType([PropTypes.object]),
  handleChange: PropTypes.func,
  handleDateChange: PropTypes.func,
  saveIntInfo: PropTypes.func,
  closeIntegrations: PropTypes.func,
  activationDate: PropTypes.string,
  clearIntFields: PropTypes.func,
  psrInfo: PropTypes.oneOfType([PropTypes.object])
};

IntegrationInfo.defaultProps = {
  intInfo: null,
  handleChange: null,
  handleDateChange: null,
  saveIntInfo: null,
  closeIntegrations: null,
  activationDate: null,
  clearIntFields: null,
  psrInfo: null
};

const withConnectState = connect(
  (state, ownProps) => ({
    psrInfo: state.psrs.psrInfo.data
  }),
  dispatch => bindActionCreators({}, dispatch)
);

const EditIntegrationInfo = withStyles(styles)(
  compose(
    withState('state', 'setState', {}),
    withHandlers({
      handleDateChange: props => name => event => {
        const { state, setState } = props;
        state[name] = getApiDateFormat(event);
        setState({ ...state });
      },
      handleChange: props => event => {
        const { state, setState } = props;
        state[event.target.name] = event.target.value;
        if (event.target.name === 'isTriadProt') {
          state.isRtQaStudy = !event.target.value && event.target.value;
          state.triadActivationDate = !event.target.value && '';
        } else {
          state[event.target.name] = event.target.value;
        }
        setState({ ...state });
      },
      saveIntInfo: props => event => {
        const { state, saveIntegrationInfo, context } = props;
        const confirmSave = () => {
          const postBody = {
            ...state
          };
          saveIntegrationInfo(postBody);
        };
        openConfirmation({
          message: GetFromCtxValue(context, 'PROTOCOL_INTEGRATION_CONFIRMATION'),
          onAction: confirmSave,
          name: 'integration'
        });
      },
      clearIntFields: props => event => {
        const { intInfo, setState } = props;
        setState({ ...intInfo });
      }
    })
  )(IntegrationInfo)
);

export default withConnectState(withAppContext(EditIntegrationInfo));
